<script setup lang="ts">
  import { computed } from 'vue';

  import { DocumentSendAudienceType } from '@/entities/DocumentSend';
  import { IconRadio } from '@/shared/ui';

  const props = withDefaults(
    defineProps<{
      modelValue: DocumentSendAudienceType | '';
      errorMessage?: string;
      radioName?: string;
      sectionClass?: string;
    }>(),
    {
      errorMessage: '',
      radioName: 'document-send-audience',
      sectionClass: 'flex flex-col gap-4 p-6',
    }
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: DocumentSendAudienceType): void;
  }>();

  const audienceType = computed({
    get: () => props.modelValue,
    set: (value: DocumentSendAudienceType) => emit('update:modelValue', value),
  });
</script>

<template>
  <section
    :class="props.sectionClass"
    data-testid="send-audience-section"
  >
    <span class="text-sm font-semibold text-gray-07">Tipo de Destinatário:</span>
    <div
      class="flex flex-col gap-4 md:flex-row md:gap-6"
      data-testid="send-audience-options"
    >
      <IconRadio
        v-model="audienceType"
        :value="DocumentSendAudienceType.CLIENT"
        variant="small"
        label="Cliente"
        :name="props.radioName"
      />
      <IconRadio
        v-model="audienceType"
        :value="DocumentSendAudienceType.SUPPLIER"
        variant="small"
        label="Fornecedor"
        :name="props.radioName"
      />
      <!-- Hidden on purpose: sends already stored as CLIENT_SUPPLIER still depend on this audience.
      <IconRadio
        v-model="audienceType"
        :value="DocumentSendAudienceType.CLIENT_SUPPLIER"
        variant="small"
        label="Cliente/Fornecedor"
        :name="props.radioName"
      />
      -->
    </div>

    <p
      v-if="props.errorMessage && !props.modelValue"
      class="text-xs text-red-16"
      data-testid="send-audience-error"
    >
      {{ props.errorMessage }}
    </p>
  </section>
</template>
